import { useEffect, useMemo, useState } from 'react';

function useObserver<T extends HTMLElement>(
  ref: React.RefObject<T>,
  options?: IntersectionObserverInit,
) {
  const [inViewport, setInViewport] = useState(false);

  const observer = useMemo(
    () =>
      new IntersectionObserver(
        ([entry]) => setInViewport(entry.isIntersecting),
        options,
      ),
    [ref],
  );

  useEffect(() => {
    const currentRef = ref.current;
    if (!currentRef) {
      return;
    }

    observer.observe(currentRef);

    return () => {
      if (observer) {
        observer.disconnect();
      }
    };
  }, []);
  return inViewport;
}
export default useObserver;
